'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _sr_RS = require('../locale/sr_RS');

var _sr_RS2 = _interopRequireDefault(_sr_RS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _sr_RS2['default'];